import { NgModule } from '@angular/core';

import { MgOverlayHideDirective } from './MgOverlayHide.directive';

@NgModule({
  declarations: [MgOverlayHideDirective],
  exports: [MgOverlayHideDirective],
})
export class MgOverlayHideModule {}
